import { render, staticRenderFns } from "./PreLine.vue?vue&type=template&id=36ccf892&scoped=true"
import script from "./PreLine.vue?vue&type=script&lang=js"
export * from "./PreLine.vue?vue&type=script&lang=js"
import style0 from "./PreLine.vue?vue&type=style&index=0&id=36ccf892&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36ccf892",
  null
  
)

export default component.exports